export const BUSINESS_INCOME_INSIGHTS_SLUG = 'income';
export const LOAN_INSIGHTS_SLUG = 'loan';

export default {
  [BUSINESS_INCOME_INSIGHTS_SLUG]: {
    title: 'Business Income',
    subtitle:
      'View the customer’s Business Income Insights across all their bank accounts',
  },
  [LOAN_INSIGHTS_SLUG]: {
    title: 'Loan',
    subtitle:
      'View the customer’s Loans Insights across all their bank accounts',
  },
};
